"use client";

import React from "react";
import { ArrowRight, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetStartedCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="253292" id="startseite" className="relative overflow-hidden bg-background py-24 lg:py-32">
            {}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-accent/5 blur-[120px] animate-pulse" />
                <div className="absolute top-[20%] -right-[10%] w-[40%] h-[60%] rounded-full bg-primary/5 blur-[120px] animate-pulse" style={{
        animationDelay: '1s'
      }} />
                <div className="absolute -bottom-[20%] left-[20%] w-[60%] h-[50%] rounded-full bg-secondary/10 blur-[120px] animate-pulse" style={{
        animationDelay: '2s'
      }} />
            </div>

            <div ref={ref} className={`container mx-auto px-4 relative z-10 max-w-4xl text-center transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
                <Badge variant="secondary" className="mb-8 px-4 py-1.5 text-xs rounded-none bg-transparent border-none tracking-widest uppercase text-muted-foreground font-sans">
                    Reflektion No. 24
                </Badge>

                <h2 className="text-5xl leading-[1.1] font-medium tracking-tight mb-6 !font-sans !text-[hsl(0,0%,0%)] md:text-6xl lg:text-[64px]">Gedanken im <span className="text-[#ad8a4e]">Fluss</span> der Zeit</h2>

                <p className="text-xl text-foreground max-w-2xl mx-auto mb-10 font-sans leading-relaxed">
                    Eine Sammlung persönlicher Essays über die Philosophie des Alltags und die leisen Verschiebungen unserer modernen Gesellschaft.
                </p>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                    <Button size="lg" className="relative overflow-hidden h-14 px-8 text-base rounded-none shadow-none bg-foreground text-background hover:bg-foreground/90 transition-all hover:-translate-y-1" asChild>
                        <Link to="/HomePage">
                            Essays lesen <ArrowRight className="ml-2 size-5" />
                        </Link>
                    </Button>
                    <Button size="lg" variant="outline" className="h-14 px-8 text-base rounded-none border-foreground/20 hover:bg-accent/10 transition-all hover:-translate-y-1 font-sans" asChild>
                        <Link to="/HomePage">
                            Über das Projekt
                        </Link>
                    </Button>
                </div>

                <div className="mt-16 flex flex-col items-center gap-3">
                    <div className="flex items-center gap-1">
                        {[...Array(5)].map((_, i) => <Star key={i} data-index={i} className="size-4 fill-accent-foreground text-accent-foreground opacity-40" />)}
                    </div>
                    <p className="text-xs uppercase tracking-widest font-medium text-muted-foreground font-sans">
                        Ein Raum für kontemplative Texte
                    </p>
                </div>
            </div>
        </section>;
}